import * as React from "react";
const SvgIcon58 = props => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 14 14" {...props}><g style={{
    stroke: "currentColor",
    fill: "none"
  }}><circle cx={7} cy={7} r={7} style={{
      stroke: "none"
    }} stroke="none" /><circle cx={7} cy={7} r={6.5} style={{
      fill: "none"
    }} /></g></svg>;
export default SvgIcon58;